import React from 'react';
import { EEhsStatus, ehsStatusMap, EUserLevels, EUserRoles, IEhs } from '@relab/alstom-ptw-shared';
import { Button } from 'semantic-ui-react';
import { TranslationComponent } from '../../../TranslationComponent';

function checkUserRoles(ehs: IEhs, userLevel: EUserLevels, userRoles: EUserRoles[]) {
  if (userLevel === EUserLevels.Admin) {
    return true;
  }

  return userRoles.some((userRoles) =>
    ehsStatusMap[ehs.status].roles(ehs.ehsType, ehs.maintenanceType).includes(userRoles)
  );
}

interface EhsStatusButtonProps {
  ehsStatus: EEhsStatus;
  onclick: (newStatus: EEhsStatus) => void;
  ehs: IEhs;
  userLevel: EUserLevels;
  userRoles: EUserRoles[];
}

export const EhsStatusButton: React.FC<EhsStatusButtonProps> = ({ ehsStatus, onclick, ehs, userLevel, userRoles }) => {
  if (checkUserRoles(ehs, userLevel, userRoles)) {
    switch (ehsStatus) {
      case EEhsStatus.NUOVO:
      case EEhsStatus.ACCETTAZIONE_N:
        return (
          <>
            <Button secondary fluid type={'submit'} onClick={() => onclick(EEhsStatus.NUOVO)}>
              <TranslationComponent stringKey={'Save draft'} />
            </Button>
            <Button primary fluid type={'submit'} onClick={() => onclick(EEhsStatus.ACCETTAZIONE_R)}>
              <TranslationComponent stringKey={'Send EHS'} />
            </Button>
          </>
        );
      case EEhsStatus.ACCETTAZIONE_R:
        return (
          <>
            <Button secondary fluid type={'submit'} onClick={() => onclick(EEhsStatus.ACCETTAZIONE_N)}>
              <TranslationComponent stringKey={'Reject'} />
            </Button>
            <Button primary fluid type={'submit'} onClick={() => onclick(EEhsStatus.ACCETTAZIONE_Y)}>
              <TranslationComponent stringKey={'Accept'} />
            </Button>
          </>
        );
      case EEhsStatus.ACCETTAZIONE_Y:
        return (
          <>
            <Button primary fluid type={'submit'} onClick={() => onclick(EEhsStatus.CHIUSURA_Y)}>
              <TranslationComponent stringKey={'Close'} />
            </Button>
          </>
        );
      default:
        return null;
    }
  } else return null;
};
